const DestinationCardSkeleton = () => {
    return (
        <div className="rounded-lg shadow-md px-8 py-4 hover:shadow-lg w-full h-96 cursor-pointer bg-blue-200 animate-pulse">
        </div>
    )
}

export default DestinationCardSkeleton